import {AppFunction, HashUrl, Role, ROLE_ADMIN, ROLE_EDITOR, ROLE_NONE, ROLE_USER} from "../misc/types";
import * as utils from "../misc/utils";
import {LoginFunction, LogoutFunction, SignupFunction} from "./login";
import {UsersFunction} from "./users";
import {User} from "../bo/user";
import {App} from "../app/app";
import {PaymentFunction} from "./payment";
import {AboutFunction} from "./about";
import {HomeFunction} from "./home";
import {ChangePasswordFunction, ResetFailFunction, ResetPasswordFunction} from "./security";
import {LibraryFunction} from "./library";
import {PlayerFunction} from "./player";
import {AccountFunction} from "./account";
import {AboutProjectFunction} from "./about_project";
import {FakebookFunction} from "./fakebook";
import {PractichordFunction} from "./practichord";
import {ReportsFunction} from "./reports";
import {UploadFunction} from "./upload";
import {ReviewFunction} from "./review";

export class Factory {

    private fnCache : { [ key : string ] : AppFunction } = {};

    private app : App;

    constructor(app: App) {
        this.app = app;
    }

    fromUrl(url: HashUrl, user: User | undefined): AppFunction {

        let fn = this.fnCache[url];
        if (fn) {
            fn.refresh();
            return fn;
        }

        fn = this.fromUrl0(url, user);

        if (fn.isCacheable()) {
            this.fnCache[url] = fn;
        }

        return fn;
    }

    private fromUrl0(url: HashUrl, user: User | undefined): AppFunction {

        const path = utils.path(url);

        console.log("fromUrl0", url, user);

        const admin = (user && user.admin) ? true : false;
        let role : Role = ROLE_NONE;
        if (admin) {
            role = ROLE_ADMIN;
        } else if (user) {
            if (user.username == "Orlando") {
                role = ROLE_EDITOR;
            } else {
                role = ROLE_USER;
            }
        }

        function match(prefix: string) {
            const p = url.substr(0, prefix.length);
            return (p === prefix);
        }

        if (match("/library")) {
            return new LibraryFunction();
        }

        if (match("/fakebook")) {
            return new FakebookFunction();
        }

        if (match("/practichord")) {
            return new PractichordFunction();
        }

        if (match("/player")) {
            const autoplay = path[2] == "autoplay";
            return new PlayerFunction(path[1] as any as number, user, role, autoplay);
        }

        if (match("/review")) {
            const token = path[1];
            return new ReviewFunction(path[1] as any as string);
        }

        if (match("/account")) {
            if (user) {
                return new AccountFunction();
            } else {
                return new SignupFunction();
            }
        }

        if (match("/users")) {
            return new UsersFunction();
        }

        if (match("/reports")) {
            return new ReportsFunction();
        }

        if (match("/upload")) {
            const id = path[1] as any as (number | undefined);
            return new UploadFunction(id);
        }

        if (match("/payment")) {
            return new PaymentFunction();
        }

        if (match("/signup")) {
            return new SignupFunction();
        }

        if (match("/login")) {
            return new LoginFunction(this.app, path[1] as unknown as string | undefined, path[2] as unknown as string | undefined);
        }

        if (match("/logout")) {
            return new LogoutFunction(this.app);
        }

        if (match("/project")) {
            return new AboutProjectFunction();
        }

        if (match("/about")) {
            const admin = user && user.admin ? true : false;
            return new AboutFunction(admin);
        }

        if (match("/security/reset-password")) {
            const isNew = (user && user.new) ? true : false;
            return new ResetPasswordFunction(path[2] as unknown as number | undefined, isNew);
        }

        if (match("/security/change-password")) {
            return new ChangePasswordFunction();
        }

        if (match("/security/reset-fail")) {
            return new ResetFailFunction();
        }

        return new AboutProjectFunction();
    }

}
